<template>
  <div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Email</label>
          <div class="control">
            <input
              type="email"
              class="input is-small"
              placeholder="Email must be associated in the Payroll System."
              v-validate="'required|email'"
              name="Email address"
              v-model="email"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Email address')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <button :class="isLoadingButton" @click="submit()">
          Submit
        </button>
        &nbsp;
        <button class="button" @click="closePage">Close</button>
      </div>
      <div class="level-right"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'

const appToast = new AppToast()

export default {
  data: () => ({
    email: '',
    isLoadingButton: 'button is-success'
  }),
  methods: {
    default() {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.email = ''
      window.close()
    },
    closePage() {
      window.close()
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.email) {
            this.isLoadingButton = 'button is-success is-loading'
            axios
              .patch(`api/resetpassword/request/${this.email}`)
              .then(response => {
                appToast.success(response.data)
                setInterval(() => {
                  this.default()
                }, 3000)
              })
              .catch(error => {
                if (error.response) {
                  appToast.danger(error.response.data)
                }
              })
              .then(() => {
                this.isLoadingButton = 'button is-success'
              })
          }
        }
      })
    }
  }
}
</script>
